<template>
    <div class="member-card">


        <pageheader text="Medlemskort"/>


        <div class="membercard">


            <div class="barcode">
                <barcode :value="barcodeValue" format="CODE128" width="2">
                    Show this if the rendering fails.
                </barcode>
            </div>

            <div class="membercard-footer">
                Medlemsnr. {{barcodeValue}}
            </div>

        </div>


    </div>
</template>

<script>
// @ is an alias to /src


export default {
    name: 'MemberCard',
    components: {

    },
    data() {
        return {
            barcodeValue: null
        }
    },
    mounted() {


        this.barcodeValue = this.$store.getUser().card_id;


    },
}
</script>


<style lang="scss">


@media only screen and (max-width: 576px) {
    .membercard {
        width: 100% !important;
        padding-top: 75% !important;
    }
}

.membercard {
    background-color: #3C1917;
    width: 60%;
    padding-top: 35%;
    position: relative
}
.barcode {
    position: absolute;
    top:40%;
    left:50%;
    transform: translate3d(-50%,-50%,0);
    -webkit-transform: translate3d(-50%,-50%,0);
    -moz-transform: translate3d(-50%,-50%,0);
    -o-transform: translate3d(-50%,-50%,0);
}

.membercard-footer {
    text-align: center;
    color: white;
    position: absolute;
    bottom:10%;
    left:50%;
    transform: translate3d(-50%,-50%,0);
    -webkit-transform: translate3d(-50%,-50%,0);
    -moz-transform: translate3d(-50%,-50%,0);
    -o-transform: translate3d(-50%,-50%,0);
}

</style>
